<template>
  <div class="Allbanner">
    <div class="banner">
      <div class="swtich" v-if="showLanguageSwitch">
        <span
          :class="isChinese ? 'unchecked_swtich' : 'checked_swtich'"
          @click="toggleLanguage(true)"
          >中文</span
        >
        <span
          :class="!isChinese ? 'unchecked_swtich' : 'checked_swtich'"
          @click="toggleLanguage(false)"
          >ENG</span
        >
      </div>
      <div class="banner-wrapper">
        <div
          class="banner-slide"
          v-for="(item, index) in banners"
          :key="index"
          :class="{ active: index === currentBannerIndex }"
          @click="handleBannerClickByIndex(index)"
          style="cursor: pointer"
        >
          <img :src="item.img" alt="" />
          <div class="banner-mask">
            <span class="banner-news">{{
              isChinese ? item.title : item.title_en
            }}</span>
          </div>
        </div>
        <div class="banner-arrow banner-arrow-left" @click="prevBanner">
          <img src="../assets/left_icon.png" alt="上一张" />
        </div>
        <div class="banner-arrow banner-arrow-right" @click="nextBanner">
          <img src="../assets/right_icon.png" alt="下一张" />
        </div>
      </div>
    </div>
    <div class="main_plate_news">
      <span
        v-for="(item, index) in topNewsList"
        :key="item.id != null ? item.id : index"
        :class="item.is_bold === 1 ? 'news2' : 'news1'"
        @click="item.id != null && goToDetail(item.id, isChinese ? 'zh' : 'en')"
        >{{ isChinese ? item.title : item.title_en }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerCarousel",
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
    topNewsList: {
      type: Array,
      default: () => [],
    },
    showLanguageSwitch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentBannerIndex: 0,
      bannerTimer: null,
      isChinese: true, // 默认选中中文
      isPaused: false, // 是否暂停自动播放
    };
  },
  watch: {
    "$route.path"() {
      this.isChinese = true;
    },
    "$route.query.categoryId"() {
      this.isChinese = true;
    },
  },
  mounted() {
    this.startBannerAutoPlay();
  },
  beforeDestroy() {
    this.stopBannerAutoPlay();
  },
  beforeUnmount() {
    this.stopBannerAutoPlay();
  },
  methods: {
    nextBanner() {
      this.pauseAutoPlay(); // 用户手动切换时停止自动播放
      this.currentBannerIndex =
        (this.currentBannerIndex + 1) % this.banners.length;
    },
    prevBanner() {
      this.pauseAutoPlay(); // 用户手动切换时停止自动播放
      this.currentBannerIndex =
        (this.currentBannerIndex - 1 + this.banners.length) %
        this.banners.length;
    },
    startBannerAutoPlay() {
      this.stopBannerAutoPlay();
      this.bannerTimer = setInterval(() => {
        if (!this.isPaused) {
          this.currentBannerIndex =
            (this.currentBannerIndex + 1) % this.banners.length;
        }
      }, 5000);
    },
    stopBannerAutoPlay() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
        this.bannerTimer = null;
      }
    },
    pauseAutoPlay() {
      this.isPaused = true;
    },
    resumeAutoPlay() {
      this.isPaused = false;
    },
    handleBannerClick(item) {
      this.pauseAutoPlay();
      console.log('点击轮播图 - 传递的 item:', JSON.parse(JSON.stringify(item)));
      console.log('点击轮播图 - item.id:', item.id);
      // 直接使用 id 跳转详情页
      if (item.id != null && item.id !== undefined && item.id !== "") {
        window.open(
          this.$router.resolve({
            name: "NewsDetail",
            params: { id: item.id },
            query: { lang: this.isChinese ? 'zh' : 'en' }
          }).href,
          "_blank"
        );
      }
    },
    handleBannerClickByIndex(index) {
      this.pauseAutoPlay();
      console.log('点击轮播图 - 通过索引点击, index:', index);
      const item = this.banners[index];
      if (item) {
        console.log('点击轮播图 - 通过索引获取的 item:', JSON.parse(JSON.stringify(item)));
        console.log('点击轮播图 - 通过索引获取的 item.id:', item.id);
        if (item.id != null && item.id !== undefined && item.id !== "") {
          window.open(
            this.$router.resolve({
              name: "NewsDetail",
              params: { id: item.id },
              query: { lang: this.isChinese ? 'zh' : 'en' }
            }).href,
            "_blank"
          );
        }
      }
    },
    toggleLanguage(isChinese) {
      this.isChinese = isChinese;
      // 可以在这里添加语言切换的其他逻辑，比如触发事件通知父组件
      this.$emit("language-change", isChinese ? "zh" : "en");
      this.$emit("update:isChinese", isChinese);
    },
    goToDetail(id, lang) {
      if (id != null && id !== undefined && id !== "")
        window.open(
          this.$router.resolve({ 
            name: "NewsDetail", 
            params: { id }, 
            query: { lang: lang || 'zh' } 
          }).href,
          "_blank"
        );
    },
  },
};
</script>

<style scoped lang="scss">
.Allbanner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 61px 0 47px 0;
}
.banner {
  width: 700px;
  height: 400px;
  position: relative;
  overflow: hidden;
  .swtich {
    width: 115px;
    height: 33px;
    position: absolute;
    top: 24px;
    left: 24px;
    z-index: 999;
    display: flex;
    overflow: hidden;
    cursor: pointer;
    .checked_swtich {
      flex: 1;
      background: #eeeeee;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 16px;
      color: #000;
      line-height: 33px;
      text-align: center;
      padding: 0;
      box-sizing: border-box;
      transition: all 0.3s ease;
      cursor: pointer;
      user-select: none;
      &:first-child {
        border-radius: 6px 0 0 6px;
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
      }
    }
    .unchecked_swtich {
      flex: 1;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      line-height: 33px;
      text-align: center;
      background: #b81c22;
      padding: 0;
      box-sizing: border-box;
      transition: all 0.3s ease;
      cursor: pointer;
      user-select: none;
      &:first-child {
        border-radius: 6px 0 0 6px;
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
      }
    }
  }
  .banner-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .banner-slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 1;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .banner-mask {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
      padding: 10px 16px;
      background: rgba(0, 0, 0, 0.6);
      .banner-news {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
  .banner-slide.active {
    opacity: 1;
    z-index: 2;
  }
  .banner-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100;
    img {
      width: 20px;
      height: 31px;
      display: block;
    }
  }
  .banner-arrow-left {
    left: 30px;
  }
  .banner-arrow-right {
    right: 30px;
  }
}
.main_plate_news {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 446px;
  width: 446px;
  text-align: left;
  span {
    width: 100%;
    display: -webkit-box; /* 1. 将对象作为弹性伸缩盒子模型显示 */
    -webkit-line-clamp: 1; /* 2. 限制块元素显示的行数（这里是1行） */
    line-clamp: 1;
    -webkit-box-orient: vertical; /* 3. 设置或检索伸缩盒对象的子元素的排列方式 */
    overflow: hidden; /* 4. 隐藏超出部分 */
    text-overflow: ellipsis; /* 5. 用省略号代替隐藏部分（配合hidden使用） */
  }
  .news1 {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #424242;
    cursor: pointer;
    transition: color 0.3s ease;
    &:hover {
      color: #dc0d1d;
    }
  }
  .news2 {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #424242;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease;
    &:hover {
      color: #dc0d1d;
    }
  }
}

/* 平板端：宽度 <= 1200px 时的布局调整 */
@media (max-width: 1200px) {
  .Allbanner {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .banner {
    width: 100%;
    height: 320px;
  }

  .main_plate_news {
    max-width: 100%;
  }
}

/* 移动端：宽度 <= 768px 时的布局调整 */
@media (max-width: 768px) {
  .Allbanner {
    margin: 24px 0;
  }

  .banner {
    height: 220px;
  }

  .banner .banner-mask .banner-news {
    font-size: 14px;
  }

  .main_plate_news {
    gap: 6px;

    .news1,
    .news2 {
      font-size: 14px;
    }
  }
}
</style>
